<template>
	<div :style="{ height: bodyHeight + 'px' }" class="home m-body">
		<van-image
			width="100%"
			height="1rem"
			:src="require('@/assets/images/m_head.png')"
		></van-image>
		
		<div class="main">
			<div class="info qjc-flex">
				<div class="weather qjc-flex">
					<van-image
						width="1.54rem"
						height="1.7rem"
						:src="weather.img?require('@/assets/images/'+ weather.img +'.png'):''"
					></van-image>
					<dl>
						<dt>{{ weather.temperature }}°C</dt>
						<dd>{{ weather.text }}<span class="place">{{ weather.city }}</span></dd>
					</dl>
				</div>
				<dl class="date qjc-texta-c">
					<dt>{{ time }}</dt>
					<dd class="qjc-fts-22">{{ date }} {{ week }}</dd>
				</dl>
			</div>
			
			<div class="modules">
				<ul class="qjc-clearfix">
					<li @click="to('https://medin.medinhealth.com/#/home/experience?from=hkhc-wap')" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/m_healthVIP.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">健康大數據VIP服務</h4>
					</li>
					<li @click="to('https://m.medinbd.com/#/')" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/m_hkhc.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">HKHC大數據體檢 </h4>
					</li>
					<li class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/m_doctor.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">名醫在線<span class="qjc-fts-28">—</span><span class="qjc-fts-24">敬請期待</span></h4>
					</li>
					<li @click="$router.push('/HK/m/shop')" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/m_shop.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">HKHC健康商城 </h4>
					</li>
				</ul>
			</div>
			
			<van-image
				@click="to('https://yx.medinbd.com/#/case/m')"
				width="100%"
				height="2.3rem"
				:src="require('@/assets/images/hkhc_case.png')"
			></van-image>
			
			<div class="health">
				<h3 class="qjc-fts-36">
					健康頻道
					<span @click="to('https://m.medinbd.com/#/study')" class="more qjc-ftw-n qjc-fts-24 qjc-fr">查看更多</span>
				</h3>
				
				<van-swipe @change="checkTab" :autoplay="5000" ref="swipe">
					<van-swipe-item v-for="(list,index) in healthList" :key="index">
						<ul v-for="item in list" :key="item.id" class="list qjc-fts-32">
							<li @click="to(item.id?'https://m.medinbd.com/#/study/detail/'+item.id:item.url)">{{ item.title }}</li>
						</ul>
					</van-swipe-item>
				</van-swipe>
				
				<ol class="tabs qjc-flex">
					<li @click="tabClick(index)" v-for="(i,index) in healthList" :key="'tab'+index" :class="{ 'active': index == healthListPage }"></li>
				</ol>
			</div>
			
			<p class="foot qjc-fts-20">
				最終解釋權歸上海米因大數據科技有限公司所有
			</p>
			
		</div>
		
		<m-footer></m-footer>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Image, Swipe, SwipeItem, Toast } from 'vant'
	Vue.use(Image)
	   .use(Swipe)
	   .use(SwipeItem)
	   .use(Toast);
	
	import MFooter from '@/components/m/Footer'
	
	import { getWeatherInfo, getHealth } from '@/utils/axios'
	
	export default{
		name: 'HKmHome',
		data() {
			return {
				bodyHeight: document.documentElement.clientHeight,
				
				weather: {
					img: '',
					text: '--',
					temperature: '--',
					city: '--'
				},//天氣狀況
				
				date: '--',
				time: '--',
				week: '--',
				
				healthList: [
					{ title: '新店曝光|把更好的月子服務，帶到您身邊', url: 'https://mp.weixin.qq.com/s/YyrXinQIEaS6r1Q0WB-Rwg' },
					{ title: '【新店開業】番禺店除甲醛現場曝光，不放過任何死角！', url: 'https://mp.weixin.qq.com/s/KTLeEAWZJNKmc1ZnOT_hJg' },
					{ title: '感謝信|來自媽媽們的「表白」', url: 'https://mp.weixin.qq.com/s/EaNQYSrhbQF6-dhaNIbg6A' },
					{ title: '熱烈祝賀安儒月子中心當選廣東省家政服務標準化技術委員會委員', url: 'https://mp.weixin.qq.com/s/WQGSGYJJxc0mjPGY4DDmSQ' },
					{ title: '產後康復除了關注身體更要關注心理', url: 'https://mp.weixin.qq.com/s/ZJpuzqZlCB6LB4V2f4kwiQ' }
				],// 默認寫死文章
				healthListPage: 0,
				
			}
		},
		components: {
			MFooter
		},
		mounted() {
			this.$nextTick(() => {
				this.getWeather();
				this.getTime();
				
				this.getHealthList();
				
			})
		},
		methods: {
			// 获取天气信息 参数：调用api下标
			getWeather(apiListIndex) {
				var getWeatherTime = localStorage.getItem('getWeatherTime'),
					differ = new Date().getTime() - (getWeatherTime?getWeatherTime:0);
				var res = '';
				if(differ > (30 * 60 * 1000)){
					var index = apiListIndex?apiListIndex:0;
					
					// 三条线路
					if(index < 3){
						getWeatherInfo(index).then(data => {
							console.log(data);
							res = data;
							if(res.wea_img){
								
								// 存储接口调取时间，存储数据，三十分钟后再次调取
								localStorage.setItem('getWeatherTime', new Date().getTime());
								localStorage.setItem('weatherInfo', JSON.stringify(res));
								
								this.showWeather(res);
							}else{
								this.getWeather(++index);
							}
							
						})
					}else{
						alert('天氣信息獲取失敗');
					}
					
				}else{
					res = JSON.parse(localStorage.getItem('weatherInfo'));
					if(res.wea_img){
						this.showWeather(res);
					}else{
						localStorage.removeItem('weatherInfo');
					}
				}
				
			},
			//展示天氣情況
			showWeather(res){
				// 天氣狀況
				this.weather.img = res.wea_img;
				this.weather.text = res.wea;// 描述
				this.weather.temperature = res.tem;// 實時氣溫
				this.weather.city = res.city
				
				// 日期
				// this.date = res.date.split('-').join('/');
				// this.week = res.week;
				
				// 隔三十分钟調取一次
				var that = this;
				setTimeout(() => {
					that.getWeather();
				}, 30 * 60 * 1000);
			},
			
			// 獲取健康頻列表
			getHealthList(){
				getHealth().then(res => {
					// console.log(res);
					
					if(res.status == 1){
						
						// 三條一頁
						var list = this.healthList.concat(res.data.data),
							forList = [];
						for(var i=0;i<list.length;i++){
							var last = forList[forList.length-1];
							if(last && last.length < 3){
								last.push(list[i]);
							}else{
								forList.push([list[i]]);
							}
						}
						this.healthList = forList;
						
					}else{
						alert(res.msg);
					}
				});
			},
			//指示器
			checkTab(index) {
				this.healthListPage = index;
			},
			// 指示器時間
			tabClick(index) {
				this.$refs.swipe.swipeTo(index);
			},
			
			// 獲取時間
			getTime() {
				// 接口無時間,獲取當前時間
				var now = new Date();
				this.time = (now.getHours()<10?'0'+now.getHours():now.getHours()) + ':' + (now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes());
				
				// 時間校準(毫秒校準)
				var speed = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
				
				// 日期
				this.date = now.getFullYear() + '/' + (now.getMonth()+1) + '/' + now.getDate();
				var weeks = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];
				this.week = weeks[now.getDay()];
				
				// 周期性一分鐘一次
				setTimeout(() => {
					this.getTime();
				}, speed);
				
			},
			
			// 跳轉連結
			to(url) {
				window.location.href = url;
			}
			
		}
	}
</script>

<style scoped>
	/* 自定義指示器只能隱藏,否則在ios上會出現文字卡頓停留 */
	.health >>> .van-swipe__indicators{
		visibility: hidden;
	}
</style>
<style lang="scss" scoped>
	.home{
		color: #5FD6FF;
		padding-top: 0.08rem;
		padding-bottom: 1.2rem;
		
		.main{
			margin: 0.24rem;
			
			&>div{
				background: linear-gradient(180deg,rgba(49,92,147,0.5) 0%,rgba(22,47,90,0.5) 100%);
				border-radius: 0.06rem;
				margin-bottom: 0.24rem;
			}
			
			.info{
				justify-content: space-between;
				align-items: center;
				
				.weather{
					justify-content: flex-start;
					align-items: center;
					
					dl{
						margin-left: 0.08rem;
						
						dt{
							font-size: 0.48rem;
							line-height: 0.48rem;
							font-weight: 400;
						}
						dd{
							font-size: 0.28rem;
							line-height: 0.28rem;
							margin-top: 0.16rem;
							
							.place{
								margin-left: 0.2rem;
							}
						}
					}
				}
				.date{
					padding-right: 0.32rem;
					
					dt{
						font-size: 0.72rem;
						line-height: 0.72rem;
					}
					dd{
						line-height: 0.22rem;
						margin-top: 0.16rem;
					}
				}
			}
			
			.modules{
				color: #E3ECFF;
				padding: 0.32rem 0.11rem 0;
				
				li{
					width: 50%;
					padding: 0 0.11rem;
					margin-bottom: 0.24rem;
					
					h4{
						margin-top: 0.12rem;
					}
				}
			}
			
			.health{
				h3{
					font-weight: 500;
					line-height: 0.95rem;
					border-bottom: 0.01rem solid #3D5E90;
					padding: 0 0.32rem;
					
					.more{
						position: relative;
						margin-right: 0.18rem;
						
						&::after{
							position: absolute;
							content: '';
							top: 50%;
							right: -0.18rem;
							width: 0.16rem;
							height: 0.16rem;
							border-top: 0.01rem solid #5FD6FF;
							border-right: 0.01rem solid #5FD6FF;
							transform: translateY(-50%)rotateZ(45deg);
						}
					}
				}
			
				.list{
					padding: 0 0.32rem;
					
					li{
						display: flex;
						align-items: center;
						position: relative;
						height: 1.55rem;
						line-height: 0.4rem;
						
						&::after{
							content: '';
							position: absolute;
							bottom: 0;
							left: 0.09rem;
							right: 0.09rem;
							border-bottom: 0.01rem dashed #3D5E90;
						}
					}
				}
				
				.tabs{
					height: 0.85rem;
					justify-content: center;
					align-items: center;
					
					li{
						width: 0.16rem;
						height: 0.16rem;
						border-radius: 0.02rem;
						background-color: #325D6C;
						margin: 0 0.12rem;
						
						&.active{
							background-color: #86D2ED;
						}
					}
				}
					
			}
			
			.foot{
				color: #6E7EA0;
				margin-top: 0.32rem;
				text-align: center;
			}
			
		}
	}
</style>
